export function getFullUrl(href) {
  let l = document.createElement('a')
  l.href = href
  return l
}
